import { exists } from '@/api'

export interface AuthoritySeries {
  display: string
  displayKana: string
  tag: string
  authorityNo: string
}

export function AuthoritySeriesFromJSON(json: any): AuthoritySeries {
  return {
    display: exists(json, 'display') ? json.display : '',
    displayKana: exists(json, 'display_kana') ? json.display_kana : '',
    tag: exists(json, 'tag') ? json.tag : '',
    authorityNo: exists(json, 'authority_no') ? String(json.authority_no) : ''
  }
}
